import React, { FC } from 'react';
import s from './SymphonyCollage.scss';
import dataHooks from '../../constants/data-hooks';

const ITEMS = [
  'recordsTile',
  'avatarSolo',
  'revenueCard',
  'orbitTile',
  'initialsBadge',
  'avatarPair',
] as const;

const SymphonyCollage: FC = () => (
  <div className={s.collage} data-hook={dataHooks.symphonyCollage} aria-hidden>
    {ITEMS.map((item) => (
      <span key={item} className={s[item]} />
    ))}
  </div>
);

export default SymphonyCollage;
